export default __webpack_public_path__ + "static/media/BestermindRegular.e58a1922.ttf";